import React from 'react';
import { match } from 'ts-pattern';

import { cn } from '@eluve/components';

import { ContentEditable } from './ContentEditable';

type Size = 1 | 2 | 3 | 4 | 5;

type HeaderElement = `h${Size}`;

type HeadingSize = '5xl' | '4xl' | '3xl' | '2xl' | 'xl' | 'lg';

const headingSizeClasses: Record<HeadingSize, string> = {
  '5xl': 'text-5xl',
  '4xl': 'text-4xl',
  '3xl': 'text-3xl',
  '2xl': 'text-2xl',
  xl: 'text-xl',
  lg: 'text-lg',
};

export interface EditableTitleProps {
  title: string;
  label?: string;
  onTitleChange: (title: string) => void;
  element?: HeaderElement;
  isReadonly?: boolean;
  size?: HeadingSize;
  /**
   * When false, hides the pencil button — the title is edited by clicking
   * directly into the text (hover shows an underline affordance).
   * @default true
   */
  editButton?: boolean;
}

export const EditableTitle: React.FC<EditableTitleProps> = ({
  title,
  label = 'Edit title',
  onTitleChange,
  isReadonly = false,
  size = '3xl',
  element: Component = 'h2',
  editButton = true,
}) => {
  const NameHeading = (
    <Component
      className={cn(
        headingSizeClasses[size],
        'inline font-medium text-wrap text-text-primary',
      )}
    >
      {title}
    </Component>
  );

  return match(isReadonly)
    .with(true, () => NameHeading)
    .otherwise(() => (
      <ContentEditable
        editButtonLabel={label}
        onContentChange={onTitleChange}
        editButton={editButton}
      >
        {NameHeading}
      </ContentEditable>
    ));
};
